

// 银行卡校验
export const bankRule = function(val,el,call){
  // var  status = /^(\d{16}|\d{19})$/.test(val);
  var  status = /^(\d{1,25})$/.test(val);
  if(!status){
    call('银行账号必须填写且应为数字！');
    el instanceof HTMLElement?el.classList.add('errInput'):'';

    return false;
  }else{
    el instanceof HTMLElement?el.classList.remove('errInput'):'';

    return true;
  }
};
// 银行卡校验
export const moneyRule = function(val,el,call){
  // var  status = /^(\d{16}|\d{19})$/.test(val);
  var  status = /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/.test(val);
  if(!status){
    call('金额必须为正整数且最多保留两位小数！');
    el instanceof HTMLElement?el.classList.add('errInput'):'';

    return false;
  }else{
    el instanceof HTMLElement?el.classList.remove('errInput'):'';

    return true;
  }
};
export const inputRule = function(val,el,call){
  var  status = /^[a-zA-Z0-9]+$/.test(val);
  console.log(val)
  console.log(status)
  if(!status){
    call('必须为数字或英文！');
    el instanceof HTMLElement?el.classList.add('errInput'):'';
    return false;
  }else{
    el instanceof HTMLElement?el.classList.remove('errInput'):'';
    return true;
  }
};
